import { render, staticRenderFns } from "./recipientsInfo.vue?vue&type=template&id=438639d0&scoped=true"
import script from "./recipientsInfo.vue?vue&type=script&lang=js"
export * from "./recipientsInfo.vue?vue&type=script&lang=js"
import style0 from "./recipientsInfo.vue?vue&type=style&index=0&id=438639d0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438639d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('438639d0')) {
      api.createRecord('438639d0', component.options)
    } else {
      api.reload('438639d0', component.options)
    }
    module.hot.accept("./recipientsInfo.vue?vue&type=template&id=438639d0&scoped=true", function () {
      api.rerender('438639d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderCenter/logisticsOrders/components/detailBox/components/recipientsInfo.vue"
export default component.exports